/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Command to verify the SMS code entered by the borrower.
 * @export
 * @interface MncapVerifySmsCodeCommand
 */
export interface MncapVerifySmsCodeCommand {
    /**
     * The one-time token originally received by the borrower via email.
     * @type {string}
     * @memberof MncapVerifySmsCodeCommand
     */
    token: string;
    /**
     * The 6-digit code received by SMS.
     * @type {string}
     * @memberof MncapVerifySmsCodeCommand
     */
    code: string;
}

/**
 * Check if a given object implements the MncapVerifySmsCodeCommand interface.
 */
export function instanceOfMncapVerifySmsCodeCommand(value: object): value is MncapVerifySmsCodeCommand {
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function MncapVerifySmsCodeCommandFromJSON(json: any): MncapVerifySmsCodeCommand {
    return MncapVerifySmsCodeCommandFromJSONTyped(json, false);
}

export function MncapVerifySmsCodeCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): MncapVerifySmsCodeCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
        'code': json['code'],
    };
}

export function MncapVerifySmsCodeCommandToJSON(json: any): MncapVerifySmsCodeCommand {
    return MncapVerifySmsCodeCommandToJSONTyped(json, false);
}

export function MncapVerifySmsCodeCommandToJSONTyped(value?: MncapVerifySmsCodeCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
        'code': value['code'],
    };
}

